import { getProductVariantPriceHistory } from '../../bind/product';
import { RuntimeClientAtom } from '@vs-shop/engine/runtime/RuntimeClient';
import * as Atom from 'effect/unstable/reactivity/Atom';
import { tagged } from '@vs-shop/engine/data/util/tagged';

type FetchProductPriceHistoryKey = {
  readonly _tag: 'FetchProductPriceHistoryKey';
  readonly productCode: string;
};

const FetchProductPriceHistoryKey = tagged<FetchProductPriceHistoryKey>(
  'FetchProductPriceHistoryKey'
);

const fetchProductPriceHistoryAtomFamily = Atom.family((key: FetchProductPriceHistoryKey) => {
  return RuntimeClientAtom.atom(getProductVariantPriceHistory(key.productCode)).pipe(
    Atom.keepAlive
  );
});

export const fetchProductPriceHistoryAtom = (productCode: string) => {
  const key = FetchProductPriceHistoryKey({ productCode });

  return fetchProductPriceHistoryAtomFamily(key);
};
